import { get, find } from 'lodash';

export default function findCurrentGroup(userState, sessionState) {
  const groups = get(userState, 'groups', []);
  const groupId = get(sessionState, 'groupId', null);

  return find(groups, { group: { id: groupId } });
}
